// src/pages/ModernHomePage.jsx
import React, { useState, useContext } from 'react';
import { EuiTitle, EuiText, EuiImage, EuiButton, EuiSpacer, EuiButtonEmpty } from '@elastic/eui';
import { UserContext } from '../Context';
import LoginForm from '../forms/LoginForm';
import RegisterForm from '../forms/RegisterForm';
import illustration from '../images/illustration.svg';
import logo from '../images/illustration.svg';
import { Link, useNavigate } from 'react-router-dom';
import { routeStudent } from '../utils/studentRouting';
import '../styles/modernTheme.css';
import '../styles/responsive.css';

const ModernHomePage = () => {
  const { user } = useContext(UserContext);
  const [isLoginView, setIsLoginView] = useState(true);
  const navigate = useNavigate();

  const handleStudentNavigation = async () => {
    await routeStudent(navigate);
  };

  const WelcomeContent = () => (
    <div style={{ textAlign: 'center' }}>
      <EuiTitle size="l">
        <h1 className="modern-heading-large">Welcome back, {user.full_name}!</h1>
      </EuiTitle>
      <EuiText>
        <p className="modern-text">You are logged in and ready to go.</p>
      </EuiText>
      <EuiSpacer size="l" />
      {user.role === 'student' ? (
        <EuiButton fill className="modern-button" onClick={handleStudentNavigation}>
          Go to My Courses
        </EuiButton>
      ) : (
        <Link to="/courses">
          <EuiButton fill className="modern-button">Go to My Courses</EuiButton>
        </Link>
      )}
    </div>
  );

  const AuthForms = () => (
    <div className="auth-card">
      <div className="auth-card__header">
        <EuiTitle size="m">
          <h2 className="modern-heading auth-card__title">
            {isLoginView ? 'Sign In' : 'Create Account'}
          </h2>
        </EuiTitle>
        <EuiText size="s" color="subdued">
          <p className="modern-text-small auth-card__subtitle">
            {isLoginView
              ? 'Welcome back! Please enter your details.'
              : 'Start your journey with us today.'}
          </p>
        </EuiText>
      </div>

      <div className="auth-card__body">
        {isLoginView ? (
          <LoginForm onSwitchToRegister={() => setIsLoginView(false)} />
        ) : (
          <RegisterForm />
        )}
      </div>

      {!isLoginView && (
        <div className="auth-link-group">
          <EuiButtonEmpty
            size="s"
            className="auth-link"
            onClick={() => setIsLoginView(true)}
          >
            Already have an account? Login
          </EuiButtonEmpty>
        </div>
      )}
    </div>
  );

  return (
    <div className="modern-container" style={{ position: 'relative' }}>
      {/* Brand at top right */}
      <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 10, padding: '1.5rem 2.5rem 0 0', display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
      </div>
      <div className="illustration-panel">
        <div className="illustration-content">
          <EuiImage src={illustration} alt="Illustration" size="xl" />
          <EuiSpacer size="xxl" />
          <EuiText color="white" textAlign="center">
            <EuiTitle size='m'>
              <h2 className="modern-heading" style={{color: "white", fontWeight: 700, textShadow: '0 2px 4px rgba(0,0,0,0.3)'}}>Where AI Meets Learning</h2>
            </EuiTitle>
            <p className="modern-text" style={{fontSize: '1.1rem', opacity: 0.95, textShadow: '0 1px 2px rgba(0,0,0,0.2)'}}>Smarter, more personalized educational experiences.</p>
          </EuiText>
        </div>
      </div>
      <div className="form-panel">
        {user ? <WelcomeContent /> : <AuthForms />}
      </div>
    </div>
  );
};

export default ModernHomePage;
